import React from 'react'
import Group from '@material-ui/icons/Group'
import CalendarIcon from '@material-ui/icons/CalendarToday'
import SettingsIcon from '@material-ui/icons/Settings'
import ContactsIcon from '@material-ui/icons/Contacts'
import SecurityIcon from '@material-ui/icons/Security'
import BarChart from '@material-ui/icons/BarChart'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import TuneIcon from '@material-ui/icons/Tune'
import AppsIcon from '@material-ui/icons/Apps'
import PaymentIcon from '@material-ui/icons/Payment'
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import SportsBasketballIcon from '@material-ui/icons/SportsBasketball';
import PersonIcon from '@material-ui/icons/Person';
import PaletteIcon from '@material-ui/icons/Palette';
import VideocamIcon from '@material-ui/icons/Videocam';
import ShareIcon from '@material-ui/icons/Share';
import COLORS from './colors'
import MyCourtIcon from '../../assets/icons/MyCourtIcon'
import { USER_ADDONS } from './userAddons'
import USER_ORG_ROLES from './userOrgRoles'
import USER_PERMISSIONS from './userPermissions'
import ORGANISATION_TYPES from './OrganisationTypes'

const { ALL, LIVESTREAM, STATS, ENGAGE, FANS } = USER_ADDONS
const { OWNER, ADMIN } = USER_ORG_ROLES
const {
  UPDATE_ORG,
  DO_BILLING,
  GET_ORG_USERS,
  LINK_YOUTUBE_ACCOUNT,
  READ_EVENT,
  READ_TEAM,
  SETUP_CMS,
  UPDATE_CHANNEL,
} = USER_PERMISSIONS

const SIDEBAR_OPTION = {
  orgMenuChoices: [
    {
      name: 'orgSettings',
      text: 'Settings',
      iconSelected: <SettingsIcon htmlColor={COLORS.orange} />,
      icon: <SettingsIcon style={{ fill: COLORS.menuChoiceGrey }} />,
      path: '/orgSetting',
      allowedAddons: ALL,
      requiredPermission: UPDATE_ORG,
    },
    {
      name: 'subscription',
      text: 'Billing',
      iconSelected: <PaymentIcon htmlColor={COLORS.orange} />,
      icon: <PaymentIcon style={{ fill: COLORS.menuChoiceGrey }} />,
      path: '/subscription',
      allowedAddons: ALL,
      requiredPermission: DO_BILLING,
    },
    {
      name: 'orgUsers',
      text: 'Users',
      iconSelected: <ContactsIcon htmlColor={COLORS.orange} />,
      icon: <ContactsIcon style={{ fill: COLORS.menuChoiceGrey }} />,
      path: '/orgUsers',
      allowedAddons: ALL,
      requiredPermission: GET_ORG_USERS,
    },
    {
      name: 'apps',
      text: 'Integrations',
      iconSelected: <AppsIcon htmlColor={COLORS.orange} />,
      icon: <AppsIcon style={{ fill: COLORS.menuChoiceGrey }} />,
      path: '/apps',
      allowedOrgAddons: ALL,
      allowedAddons: ALL,
      requiredPermission: LINK_YOUTUBE_ACCOUNT,
      payLocked: true,
    },
  ],
  SIDEBAR_OPTIONS_BY_ORG_TYPE: {
    [ORGANISATION_TYPES.ORG_CLUB]: [
      {
        name: 'calendar',
        text: 'Calendar',
        icon: <CalendarIcon />,
        iconSelected: <CalendarIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: [LIVESTREAM, STATS, ENGAGE],
        allowedAddons: ALL,
        requiredPermission: READ_EVENT,
        payLocked: true,
      },
      {
        name: 'players',
        text: 'Players',
        icon: <PersonIcon />,
        iconSelected: <PersonIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: [STATS],
        allowedAddons: [STATS],
        requiredPermission: READ_TEAM,
      },
      {
        name: 'teamSettings',
        text: 'Teams',
        icon: <Group />,
        iconSelected: <Group style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        requiredPermission: READ_TEAM,
      },
      {
        name: 'courts',
        text: 'Courts',
        iconSelected: <MyCourtIcon color={COLORS.orange} />,
        icon: <MyCourtIcon style={{ fill: COLORS.menuChoiceGrey }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        allowedUserOrgRoles: [OWNER, ADMIN],
      },
      {
        name: 'studio',
        text: 'Studio',
        icon: <VideocamIcon />,
        iconSelected: <VideocamIcon style={{ fill: COLORS.orange }} />,
        // Studio is a Pro tier feature, not an add-on. The link is for anyone holding a
        // Livestream seat in the org; the page itself lists only the games they are assigned to.
        allowedOrgAddons: [LIVESTREAM],
        allowedAddons: [LIVESTREAM],
        allowedUserOrgRoles: ALL,
      },
    ],
    [ORGANISATION_TYPES.ORG_LEAGUE]: [
      {
        name: 'calendar',
        text: 'Calendar',
        icon: <CalendarIcon />,
        iconSelected: <CalendarIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: [LIVESTREAM, STATS, ENGAGE],
        allowedAddons: ALL,
        requiredPermission: READ_EVENT,
        payLocked: true,
      },
      {
        name: 'players',
        text: 'Players',
        icon: <PersonIcon />,
        iconSelected: <PersonIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: [STATS],
        allowedAddons: [STATS],
        requiredPermission: READ_TEAM,
      },
      {
        name: 'stats',
        text: 'Statistics',
        icon: <BarChart />,
        iconSelected: <BarChart style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: [STATS],
        allowedAddons: [STATS],
        allowedUserOrgRoles: [OWNER, ADMIN],
        payLocked: true,
        requiresTeam: true,
      },
      {
        name: 'teamSettings',
        text: 'Teams',
        icon: <Group />,
        iconSelected: <Group style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        requiredPermission: READ_TEAM,
      },
      {
        name: 'courts',
        text: 'Courts',
        iconSelected: <MyCourtIcon color={COLORS.orange} />,
        icon: <MyCourtIcon style={{ fill: COLORS.menuChoiceGrey }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        allowedUserOrgRoles: [OWNER, ADMIN],
      },
    ],
    [ORGANISATION_TYPES.ORG_COMPETITION]: [
      {
        name: 'calendar',
        text: 'Calendar',
        icon: <CalendarIcon />,
        iconSelected: <CalendarIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        requiredPermission: READ_EVENT,
      },
      {
        name: 'cms',
        text: 'CMS',
        icon: <AccountTreeIcon />,
        iconSelected: <AccountTreeIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        requiredPermission: SETUP_CMS,
      },
      {
        name: 'teams',
        text: 'Teams',
        icon: <Group />,
        iconSelected: <Group style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        requiredPermission: READ_TEAM,
      },
      {
        name: 'players',
        text: 'Players',
        icon: <PersonIcon />,
        iconSelected: <PersonIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        requiredPermission: READ_TEAM,
      },
      {
        name: 'courts',
        text: 'Courts',
        iconSelected: <MyCourtIcon color={COLORS.orange} />,
        icon: <MyCourtIcon style={{ fill: COLORS.menuChoiceGrey }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        allowedUserOrgRoles: [OWNER, ADMIN],
      },
      {
        name: 'branding',
        text: 'Branding',
        icon: <PaletteIcon />,
        iconSelected: <PaletteIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        allowedUserOrgRoles: [OWNER, ADMIN],
      },
    ],
    [ORGANISATION_TYPES.ORG_FEDERATION]: [
      {
        name: 'calendar',
        text: 'Calendar',
        icon: <CalendarIcon />,
        iconSelected: <CalendarIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        requiredPermission: READ_EVENT,
      },
      {
        name: 'cms',
        text: 'CMS',
        icon: <AccountTreeIcon />,
        iconSelected: <AccountTreeIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        requiredPermission: SETUP_CMS,
      },
      {
        name: 'clubs',
        text: 'Clubs',
        icon: <SportsBasketballIcon />,
        iconSelected: <SportsBasketballIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        // Not READ_CMS: a Statistician-only member holds that (the stats app needs it) but has no
        // business browsing the org's clubs. READ_TEAM is what every other member reads it with.
        requiredPermission: READ_TEAM,
      },
      {
        name: 'players',
        text: 'Players',
        icon: <PersonIcon />,
        iconSelected: <PersonIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        requiredPermission: READ_TEAM,
      },
      {
        name: 'courts',
        text: 'Courts',
        iconSelected: <MyCourtIcon color={COLORS.orange} />,
        icon: <MyCourtIcon style={{ fill: COLORS.menuChoiceGrey }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        allowedUserOrgRoles: [OWNER, ADMIN],
      },
      {
        name: 'branding',
        text: 'Branding',
        icon: <PaletteIcon />,
        iconSelected: <PaletteIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: ALL,
        allowedAddons: ALL,
        allowedUserOrgRoles: [OWNER, ADMIN],
      },
      {
        name: 'distribution',
        text: 'Distribution',
        icon: <ShareIcon />,
        iconSelected: <ShareIcon style={{ fill: COLORS.orange }} />,
        allowedOrgAddons: [FANS, ENGAGE],
        allowedAddons: ALL,
        requiredPermission: UPDATE_CHANNEL,
        payLocked: true,
      },
      {
        name: 'studio',
        text: 'Studio',
        icon: <VideocamIcon />,
        iconSelected: <VideocamIcon style={{ fill: COLORS.orange }} />,
        // Studio is a Pro tier feature, not an add-on. The link is for anyone holding a
        // Livestream seat in the org; the page itself lists only the games they are assigned to.
        allowedOrgAddons: [LIVESTREAM],
        allowedAddons: [LIVESTREAM],
        allowedUserOrgRoles: ALL,
      },
    ],
  },
  PROFILE_ITEMS: [
    {
      name: 'profile',
      text: 'Profile',
      icon: <PersonOutlineIcon />,
      iconSelected: <PersonOutlineIcon style={{ fill: COLORS.orange }} />,
      allowedAddons: ALL,
      allowedUserOrgRoles: ALL,
    },
    {
      name: 'preferences',
      text: 'Preferences',
      icon: <TuneIcon />,
      iconSelected: <TuneIcon style={{ fill: COLORS.orange }} />,
      allowedAddons: ALL,
      allowedUserOrgRoles: ALL,
    },
    {
      name: 'security',
      text: 'Security',
      icon: <SecurityIcon />,
      iconSelected: <SecurityIcon style={{ fill: COLORS.orange }} />,
      allowedAddons: ALL,
      allowedUserOrgRoles: ALL,
    },
  ],
}

export default SIDEBAR_OPTION
